import React, { useEffect } from "react";
import _ from "lodash";
import styles from "./RecentNotesBar.module.scss";
import { useQuery } from "@apollo/client";
import useNotes from "../Notes/useNotes";
import useCorpPlan from "../../hooks/useCorpPlan";
import { useDepartmentFilter } from "../../context/departmentFilterContext";
import { GET_NOTES } from "../../utils/query";

import { Button, Drawer, Typography } from "@material-ui/core";
import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";

import NotesList from "../Notes/NotesList";
import AddEditNoteDialog from "../AddEditNoteDialog/AddEditNoteDialog";

const RecentNotesBar = ({ open, handleClose, auth, snack, org = {}, fetch }) => {
  const { id: orgId, fiscalYear } = org;

  const { corpForSelectedYear } = useCorpPlan({ orgId, fiscalYear });
  const currCorpPlanId = _.get(corpForSelectedYear, "id");

  const { departmentFilter } = useDepartmentFilter();
  const deptFilterSpid = _.get(departmentFilter, "sharedPlanId");

  const { data, refetch } = useQuery(GET_NOTES, {
    variables: {
      organization: orgId,
      corpPlan: currCorpPlanId,
      sharedPlanId: deptFilterSpid,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const {
    targetNote,
    addEditOpen,
    handleAddEdit,
    handleClose: handleCloseNoteDialog,
    handleChangeFile,
    handleChangeText,
    handleCreate,
    handleUpdate,
    handleDelete,
    handleRemoveImage,
    handleCopyImageToClipboard,
    handleOpenFileInNewTab,
    // handlePin,
  } = useNotes({
    user: auth,
    snack,
  });

  useEffect(() => {
    refetch();
  }, [fetch]);

  const notesData = _.get(data, "notes", {});
  const notes = _.get(notesData, "notes", []);

  return (
    <>
      <Drawer variant="temporary" anchor="right" open={open} onClose={handleClose} PaperProps={{ className: styles.paper }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h5">Recent Notes</Typography>
          <Button
            startIcon={<Icon path={mdiPlus} size={1} color="#fff" />}
            color="primary"
            variant="contained"
            onClick={() => handleAddEdit(true)}
          >
            New Note
          </Button>
        </div>
        <NotesList
          notes={notes}
          handleOpenFile={handleOpenFileInNewTab}
          toolsProps={{
            // handlePin,
            handleDelete,
            handleEdit: (note) => handleAddEdit(true, note),
            handleRemoveImage,
            handleCopyImage: handleCopyImageToClipboard,
          }}
        />
      </Drawer>
      <AddEditNoteDialog
        open={addEditOpen}
        note={targetNote}
        orgId={orgId}
        currCorpPlanId={currCorpPlanId}
        deptFilterSpid={deptFilterSpid}
        handleCreate={handleCreate}
        handleUpdate={handleUpdate}
        handleChangeFile={handleChangeFile}
        handleChangeText={handleChangeText}
        handleClose={handleCloseNoteDialog}
      />
    </>
  );
};

export default RecentNotesBar;
